import React from "react"
import {Box, Container} from "@material-ui/core";

const Footer = () => {
    return (
        <Box className="footer">
            <Container className="secondary-header-container">
                <Box className="secondary-header-links">
                    <span>&copy; 2021 TheBestMomsInTheWorld.com All Rights Reserved Kate and Karen are the best moms ever we love you!</span>
                </Box>
            </Container>

        </Box>
    )
}

export default Footer